import { shopifyAPI } from "../utils/shopifyAPI";

class BlogSearch extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      inputText: this.querySelector("input"),
      displayResultBlock: this.querySelector("#blog-search-result"),
      sectionId: "ajax-search-articles",
      renderingResultSelectors: ["#blog-search-result"],
      hideButton: this.querySelector(".js-search-hide"),
    };

    this.elements.inputText.addEventListener(
      "keyup",
      this.getSearchArticles.bind(this)
    );
    this.elements.inputText.addEventListener(
      "click",
      this.getSearchArticles.bind(this)
    );
    this.elements.inputText.addEventListener(
      "focusout",
      this.hideResults.bind(this)
    );
    this.elements.hideButton.addEventListener(
      "click",
      this.hideResults.bind(this)
    );
  }

  async getSearchArticles(e) {
    const unfocusInp = e.key === "Escape" ? true : false;

    if (this.elements.inputText.value.trim() == "" || e.key === "Escape") {
      this.hideResults(unfocusInp);
      return;
    }

    const text = await shopifyAPI.suggest(
      {
        q: this.elements.inputText.value.trim(),
        resources: {
          type: "article",
        },
        section_id: this.elements.sectionId,
      },
      this.elements.renderingResultSelectors
    );

    const resultsMarkup = new DOMParser().parseFromString(text, "text/html");
    if (
      resultsMarkup.querySelector(this.elements.renderingResultSelectors[0])
    ) {
      this.showResults();
    } else {
      this.hideResults();
    }
  }

  hideResults(unfocus) {
    this.elements.displayResultBlock.classList.add(
      "jc-opacity-0",
      "jc-invisible"
    );
    this.elements.displayResultBlock.style.height = "0";
    this.elements.hideButton.classList.add("jc-hidden");
    this.elements.inputText.style.paddingRight = "";
    if (unfocus) {
      this.elements.inputText.blur();
    }
  }

  showResults() {
    this.elements.displayResultBlock.classList.remove(
      "jc-opacity-0",
      "jc-invisible"
    );
    this.elements.displayResultBlock.style.height =
      this.elements.displayResultBlock.querySelector("ul").offsetHeight + "px";
    this.elements.hideButton.classList.remove("jc-hidden");
    this.elements.inputText.style.paddingRight = "50px";
  }
}

customElements.define("blog-search", BlogSearch);
